module.exports = __webpack_public_path__ + "img/runway_east.b89b679a.jpg";